import { values } from "@/mocks/gossip";
import { SectionHeading } from "./SectionHeading";

const TEAM_BG =
  "https://readdy.ai/api/search-image?query=editorial%20team%20workspace%20with%20timeline%20boards%20and%20warm%20desk%20lamps%2C%20stylized%20abstract%20newsroom%20illustration%2C%20coral%20and%20teal%20accents%20on%20cream%20backdrop&width=1200&height=760&seq=team&orientation=landscape";

export default function About() {
  return (
    <section id="about" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <SectionHeading
              kicker="关于吃瓜大全"
              title="我们不是带节奏，只是把瓜摆整齐"
              desc="吃瓜大全是一份持续更新的娱乐事件资料库。我们相信，真正值得围观的热点，值得被完整、可溯源、有时间线地记录下来，而不是被七零八落地冲散在信息流里。"
            />
            <div className="mt-6 space-y-4">
              <div className="flex gap-4">
                <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className="ri-compass-3-line text-lg"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">我们的定位</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                    面向想快速、完整了解热点事件来龙去脉的"吃瓜群众"。无论你是刚点进热搜的路人，还是追了整个月的深度爱好者，都能在这里找到适合自己的入口。
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className="ri-contacts-book-line text-lg"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">资料从哪来</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                    主要基于官方声明、公告、公开通告等多方公开信源交叉整理；涉及传闻的部分一律标注"待核实"并说明语境，重要反转会及时更新并修正此前归档。
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-900">
                  <i className="ri-user-community-line text-lg"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">大家怎么看</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                    常被读者评价为"终于有人把来龙去脉整理清楚了""比自己在各平台翻半天高效太多"。我们珍视每一份"一次吃透"的反馈，这也是持续更新的动力。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-2xl border border-background-200">
              <img
                src={TEAM_BG}
                alt="吃瓜大全编辑部整理事件档案的氛围图"
                className="h-64 w-full object-cover md:h-80"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-5 right-2 rounded-2xl border border-background-200 bg-background-50 px-5 py-4 shadow-sm md:right-6">
              <div className="font-heading text-2xl font-black text-primary-600">1,280+</div>
              <div className="mt-0.5 text-xs text-foreground-500">份事件档案持续可查</div>
            </div>
          </div>
        </div>

        {/* principles */}
        <div className="mt-16">
          <div className="text-center">
            <SectionHeading kicker="我们坚持的内容原则" title="四条底线，贯穿每一份档案" align="center" />
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div
                key={v.title}
                className="rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
                  <i className={v.icon + " text-2xl"}></i>
                </span>
                <h3 className="font-heading mt-4 text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}